// Create React App inlines REACT_APP_* vars at BUILD time, not runtime.
// If this is empty in production, the var was missing when `npm run build` ran
// (e.g. only set in Firebase Functions config or only present on the server).
export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA || "";

if (!RECAPTCHA_SITE_KEY && typeof window !== "undefined") {
  // eslint-disable-next-line no-console
  console.error(
    "REACT_APP_RECAPTCHA is missing from the production bundle. " +
      "Export it before `npm run build` (see howToDeploy.txt). " +
      "reCAPTCHA widgets will be hidden until it is set."
  );
}
